import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    pubKey: String,
    clientSecret: String
  }

  static targets = ['paymentElement', 'message'];

  connect() {
    this.stripe = Stripe(this.pubKeyValue);
    this.elements = stripe.elements(this.elementsOptions());
    this.paymentElement = elements.create('payment');
    this.paymentElement.mount(this.paymentElementTarget);
  }

  elementsOptions() {
    return {
      clientSecret: this.clientSecretValue,
      appearance: {

      }
    }
  }

  submitPayment(e) {
    e.preventDefault();
    const {error} = this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: {
        return_url: ""
      }
    })

    if (error) {
      this.messageTarget.textContent = error.message;
    }
  }
}